import React from "react";
import ListImage from "../../assets/img/list-att-icon.svg";
import mppIcon from "../../assets/img/mppIcon.svg"
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { SCRL_RESET_LIST } from "../../actions/types";

const QuestionBank = () => {

    let navigate = useNavigate();

    const dispatch = useDispatch();

    return (
        <div className="containerMain">

            <div className="payment_reversal_container">

                <div
                    className="payment_reversal_container_pending"
                    onClick={() => {
                        navigate("/qb/add")
                    }}
                >

                    <img
                        src={mppIcon}
                        alt="add course"
                        className="mb-3"
                    />

                    <span className="payment_reversal_container_text">
                        Create QB
                    </span>

                </div>

                <div
                    className="payment_reversal_container_history"
                    onClick={() => {
                        dispatch({ type: SCRL_RESET_LIST });
                        navigate("/qb/list");
                    }}
                >

                    <img
                        src={ListImage}
                        alt="subject list"
                        className="mb-3"
                    />

                    <span className="payment_reversal_container_text">
                        List of QBs
                    </span>

                </div>

            </div>

        </div>
    );
}
export default QuestionBank;
